import type { Comment } from '@tunasong/schemas'
import { Node } from 'slate'

/**
 * Read the text body of a comment by walking its Slate tree.
 * Returns '' for empty or whitespace-only comments so callers can short-circuit.
 */
export const commentText = (comment: Pick<Comment, 'children'>): string =>
  (comment.children ?? [])
    .map(child => Node.string(child as never))
    .join('\n')
    .trim()
